export default __webpack_public_path__ + "f87ad817eda1b3abf11cf5ab74bcae1c.jpg";